module.exports = __webpack_public_path__ + "540ccd8ae43db7c489ed17341c6a6204.png";